module.exports = __webpack_public_path__ + "img/rabby-logo.062c6587.webp";